import { createSvgIcon } from '@mui/material/utils';

export const DeviasChevronDown = createSvgIcon(
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.20005 9.59998L12 14.4L16.8 9.59998"
      stroke="#3F455A"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>, 'DeviasChevronDown'
);
